const INITIAL_STATE = {
  enquiryList: {},
  addEnquiry: {},
  updateEnquiry: {},
  nonServiceableEnquiry: {},
  errors: {},
}

const serviceOrdeerEnquiry = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_ORDER_ENQUIRY':
    return { ...state, ...INITIAL_STATE, enquiryList: action.data }
  case 'GET_SERVICE_ORDER_ENQUIRY_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_SRVICE_ORDER_ENQUIRY':
    return { ...state, ...INITIAL_STATE, addEnquiry: action.data }
  case 'ADD_SRVICE_ORDER_ENQUIRY_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_SERVICE_ORDER_ENQUIRY':
    return { ...state, ...INITIAL_STATE, updateEnquiry: action.data }
  case 'UPDATE_SERVICE_ORDER_ENQUIRY_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_NON_SERVICEABLE_ENQUIRY':
    return { ...state, ...INITIAL_STATE, nonServiceableEnquiry: action.data }
  case 'ADD_NON_SERVICEABLE_ENQUIRY_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }  
  default:
    return { ...state }
  }
};

export default serviceOrdeerEnquiry;
